const FEATURE_GATES = {
  contract: 'contract_module',
  legalNews: 'news_hub',
};

const getAvailableTourIds = (state) => {
  const features = state.subscription?.data?.features || {};
  return Object.keys(state.onboarding.tours).filter((tourId) => {
    const gate = FEATURE_GATES[tourId];
    return !gate || features[gate];
  });
};

export const selectOnboarding = (state) => state.onboarding;

export const selectTourStatus = (state, tourId) =>
  state.onboarding.tours[tourId] || { completed: false, completedAt: null };

export const selectCompletedCount = (state) => {
  const availableIds = getAvailableTourIds(state);
  return availableIds.filter((id) => state.onboarding.tours[id]?.completed).length;
};

export const selectTotalCount = (state) => getAvailableTourIds(state).length;

export const selectProgressPercent = (state) => {
  const total = selectTotalCount(state);
  if (total === 0) return 100;
  return Math.round((selectCompletedCount(state) / total) * 100);
};

export const selectIsOnboardingActive = (state) => {
  const { loaded, allCompleted, skippedAt } = state.onboarding;
  // Don't show onboarding until user-specific state is loaded
  if (!loaded) return false;
  return !allCompleted && !skippedAt;
};

export const selectActiveTour = (state) => state.onboarding.activeTour;

export const selectAvailableTours = (state) => {
  const availableIds = getAvailableTourIds(state);
  return availableIds.map((id) => ({
    id,
    ...state.onboarding.tours[id],
  }));
};
